import { FocusEvent } from 'react';
import { DATETIME_CHECKBOX_ID } from '../../../../constants';

export const clickedOnDatetimeCheckbox = (
  event: FocusEvent<HTMLInputElement>
) =>
  (event.nativeEvent.relatedTarget as HTMLElement)?.id === DATETIME_CHECKBOX_ID;
